var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.875H16.4375H14ZM18.875 5.875H16.4375H18.875ZM16.4375 5.875V3.4375V5.875ZM16.4375 5.875V8.3125V5.875ZM1 14V13.1875C1 11.6791 1.59922 10.2324 2.66583 9.16583C3.73244 8.09922 5.17908 7.5 6.6875 7.5V7.5C8.19592 7.5 9.64256 8.09922 10.7092 9.16583C11.7758 10.2324 12.375 11.6791 12.375 13.1875V14H1ZM6.6875 7.5C7.54945 7.5 8.3761 7.15759 8.9856 6.5481C9.59509 5.9386 9.9375 5.11195 9.9375 4.25C9.9375 3.38805 9.59509 2.5614 8.9856 1.9519C8.3761 1.34241 7.54945 1 6.6875 1C5.82555 1 4.9989 1.34241 4.3894 1.9519C3.77991 2.5614 3.4375 3.38805 3.4375 4.25C3.4375 5.11195 3.77991 5.9386 4.3894 6.5481C4.9989 7.15759 5.82555 7.5 6.6875 7.5V7.5Z",
    stroke: "#999999",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupIconMobile);
export default __webpack_public_path__ + "static/media/signup-icon-mobile.801535d757e654d0c7009dbbb61f708d.svg";
export { ForwardRef as ReactComponent };